import { render, staticRenderFns } from "./BookingListTemplate.vue?vue&type=template&id=1b1e557a"
import script from "./BookingListTemplate.vue?vue&type=script&lang=js"
export * from "./BookingListTemplate.vue?vue&type=script&lang=js"
import style0 from "./BookingListTemplate.vue?vue&type=style&index=0&id=1b1e557a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports